import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "well_session_token";

export const getToken = () => {
  try { return localStorage.getItem(TOKEN_KEY) || ""; } catch (e) { return ""; }
};

export const setToken = (token) => {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch (e) { /* ignore */ }
};

const api = axios.create({
  baseURL: API,
  withCredentials: true, // still send cookie when same-site cookies are allowed
});

// Attach Authorization header on every request — works even when 3rd party cookies are blocked.
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
